import React from 'react';
import { Input, Box, Flex, Icon, styled } from '@goodrx/matisse';
import { EvidenceBlock } from 'app/types/Infermedica';
import { flatten } from 'lodash';
import { TriageDatabase } from './blocks';
import { TriageBlockChildProps } from './TriageBlock';

export const compileEvidence = (evidence: Record<string, EvidenceBlock[] | undefined>) =>
  flatten(Object.values(evidence)).filter(Boolean) as EvidenceBlock[];

export const createDiagnosisPayload = (dataValues: TriageDatabase) => ({
  evidence: compileEvidence(dataValues.evidence),
});

export const StyledForm = styled.form`
  min-width: 50%;
  max-width: 75%;
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 12px;
`;

export const ChatInput = styled(Input).attrs({
  styles: {
    Field: {
      width: '100%',
    },
  },
})`
  resize: none;
  border: 0;
  width: 100%;
  min-width: 100px;
  border: 1px solid ${(p) => p.theme.colors.greyLight};
  outline: none;
  font-size: 16px;
  padding: 16px;
  border-radius: 8px;
  font-family: Avenir;
`;

export const BaseChatBubble = styled.div`
  padding: 12px;
  border-radius: 12px;
  max-width: 75%;
  width: auto;

  & + & {
    margin-top: 8px;
  }
`;

// @ts-ignore
export const SenderChatBubble = styled(BaseChatBubble)`
  align-self: flex-start;
  background: ${(p) => p.theme.colors.greyLightest};
`;

export const ReceiverChatBubble = styled(BaseChatBubble)`
  background: ${(p) => p.theme.colors.primary};
  color: white;
`;

export const Badge = styled.span`
  background: ${(p) => p.theme.colors.greyLight};
  padding: 1px 4px;
  font-weight: 500;
  border-radius: 4px;
  white-space: nowrap;
`;

export const SavedResponseWrapper: React.FC<Pick<TriageBlockChildProps, 'isPrevious' | 'removeBlock'>> = ({
  children,
  isPrevious,
  removeBlock,
}) => (
  <Flex width="100%" alignSelf="flex-end" alignItems="center" justifyContent="flex-end" maxWidth="75%" my={2}>
    {isPrevious && (
      <Box mr={2} style={{ cursor: 'pointer' }} onClick={removeBlock}>
        <Icon name="undo-variant" color="greyDarker" size={24} />
      </Box>
    )}

    <ReceiverChatBubble>{children}</ReceiverChatBubble>
  </Flex>
);
